import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { CareerDao } from '@app/dao/career/career.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { combineLatest } from 'rxjs';
import { EaEarningFormComponent } from '../ea-earning-form/ea-earning-form.component';
import { PrProfessionFormBuilder } from './ea-profession-form.builder';

@Component({
    selector: 'ea-profession-form',
    templateUrl: './ea-profession-form.component.html',
    styleUrls: ['./ea-profession-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaEarningFormComponent),
        },
    ],
    standalone: false
})
export class EaProfessionFormComponent
  extends PrProfessionFormBuilder
  implements OnInit
{
  users: any[];
  references: any;
  groupes: any[];
  categories: any[];
  companyActivitySectors = [];
  removeType: string;

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private careerDao: CareerDao,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  get title() {
    switch (this.type) {
      case 'SALARY':
        this.removeType = 'ce salaire';
        return this.generateTitle(
          'Modifier le salaire',
          'Ajouter un nouveau salaire',
        );
      case 'RETIREMENT':
        this.removeType = 'cette retraite';
        return this.generateTitle(
          'Modifier la retraite',
          'Ajouter une nouvelle retraite',
        );
      case 'DIVIDEND':
        this.removeType = 'ce revenu de capitaux mobiliers';
        return this.generateTitle(
          'Modifier le revenu de capitaux mobiliers',
          'Ajouter un nouveau revenu de capitaux mobiliers',
        );
      case 'BIC':
        this.removeType = 'ce BIC';
        return this.generateTitle(
          'Modifier le revenu BIC',
          'Ajouter un nouveau revenu BIC',
        );
      case 'BNC':
        this.removeType = 'ce BNC';
        return this.generateTitle(
          'Modifier le revenu BNC',
          'Ajouter un nouveau revenu BNC',
        );
      case 'PENSION':
        this.removeType = 'cette pension';
        return this.generateTitle(
          'Modifier la pension',
          'Ajouter une nouvelle pension',
        );
    }
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return editTitle + ' “' + this.entity.label + '”';
  }

  get type() {
    return this.form.controls.type.value;
  }

  get label() {
    switch (this.type) {
      case 'RETIREMENT':
        return 'Ancienne profession';
      case 'DIVIDEND':
        return 'Nom du revenu de capitaux mobiliers';
      case 'PENSION':
        return 'Nom de la pension';
      default:
        return 'Intitulé de poste';
    }
  }

  removeEarning(index) {
    let earning = this.form.value.earnings[index];
    if (earning.id) {
      earning.accountId = this.users[0].accountId;

      this.prFormService.loading();
      this.careerDao.deleteEarning(earning).subscribe(
        success => {
          this.prFormService.loaded();
          this.notificationService.success('La supression a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La supression a échoué');
        },
      );
    } else this.earnings.removeAt(index);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.careerDao.getReferences(),
      this.referenceDao.getCompanyActivitySectors(),
    ]).subscribe(([users, references, companyActivitySectors]) => {
      this.users = users;
      this.references = references;
      this.groupes = references.groupes;
      this.categories = references.categories;
      this.companyActivitySectors = companyActivitySectors;
    });
  }

  updateGroupe(event) {
    this.categories = this.references.categories.filter(
      c => c.groupe === event,
    );
  }

  updateCategorie(event) {
    let groupe = this.references.categories.find(
      c => c.categorie === event,
    ).groupe;
    this.form.controls['groupe'].setValue(groupe);
    if (
      event !== null &&
      ['CADRE_PUBLIC', 'PROFESSEUR_INSTITUTEUR'].includes(event)
    ) {
      this.form.controls['workInPublic'].setValue(true);
    }
  }

  extract() {
    let dto = super.extract();
    dto.accountId = this.users[0].accountId;
    return dto;
  }

  onSubmit() {
    this.prFormService.loading();
    this.careerDao.saveProfession(this.extract()).subscribe(
      success => {
        this.prFormService.loaded();
        this.notificationService.success('La sauvegarde a réussi');
      },
      errors => {
        console.error(errors);
        this.prFormService.loaded();
        this.notificationService.error('La sauvegarde a échoué');
      },
    );
  }

  deleteProfession() {
    this.careerDao.deleteProfession(this.entity).subscribe(
      success => {
        console.log(success);
      },
      error => {
        console.warn(error);
      },
    );
    this.prFormService.close();
  }

  onCancel() {
    this.prFormService.close();
  }
}
